import { Injectable } from '@angular/core';
import { AppState } from '@shared/app-state';
import { combineLatest, filter, from, Observable, switchMap } from 'rxjs';
import { BaseService } from './base.service';
import { DataApiService } from './data-api.service';
import { LoginService } from './login.service';
import { OrderOnBehalfService } from './order-on-behalf.service';
import { OrdersDataService } from './orders-data.service';

@Injectable({
	providedIn: 'root'
})
export class BagCountService extends BaseService {

	isLoggedIn: Observable<boolean>;

	constructor(
		private orderOnBehalfService: OrderOnBehalfService,
		private ordersDataService: OrdersDataService,
		private dataApiService: DataApiService,
		private loginService: LoginService,
		private appState: AppState
	) {
		super();

		this.isLoggedIn = this.loginService.IsLoggedInObservable();

		// One subscription for the life of the service. switchMap drops a customer
		// change that is still resolving so a later selection cannot be overwritten.
		this.subscriptions.push(
			combineLatest([
				this.orderOnBehalfService.customerAsObservable(),
				this.isLoggedIn
			]).pipe(
				filter(([, loggedIn]) => loggedIn),
				switchMap(() => from(this.orderOnBehalfService.getCustomerOrUserNo()))
			).subscribe(customerNo => {
				void this.countUpdateFromBackend(customerNo);
			})
		);

		this.subscriptions.push(this.ordersDataService.orderDataChanged.subscribe(customerNo => {
			void this.countUpdateFromBackend(customerNo);
		}));
	}

	private saveCount(orderItemCount: number, orderMiscItemCount: number): void {
		const currentBagDisplay = this.appState.bagDisplay.getValue();
		currentBagDisplay.FullFrames = orderItemCount;
		currentBagDisplay.AccessoriesAndTools = orderMiscItemCount;

		this.appState.bagDisplay.next(currentBagDisplay);
	}

	public async countUpdateFromBackend(customerNo?: string | null) {
		const crmTicketId = this.appState.appModeIsAfterSales()
			? this.appState.afterSalesCRMCaseNo?.value
			: undefined;

		const orders = await this.dataApiService.getOrderIds(customerNo, crmTicketId);

		if (orders) {
			const framesAmount = orders.sum(order => order.getFullFramesAmount());
			const miscAmount = orders.sum(order => order.getMiscAmount());
			this.saveCount(framesAmount, miscAmount);
		}
	}

}
